import React from "react"

export const ImportIcon = ({ className }) => {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M11.8798 14.99C11.6898 14.99 11.4998 14.92 11.3498 14.77L8.78977 12.21C8.49977 11.92 8.49977 11.44 8.78977 11.15C9.07977 10.86 9.55977 10.86 9.84977 11.15L11.8798 13.18L13.9098 11.15C14.1998 10.86 14.6798 10.86 14.9698 11.15C15.2598 11.44 15.2598 11.92 14.9698 12.21L12.4098 14.77C12.2598 14.92 12.0698 14.99 11.8798 14.99Z"
        fill="#1D1D1D"
      />
      <path
        d="M11.8799 14.92C11.4699 14.92 11.1299 14.58 11.1299 14.17V4C11.1299 3.59 11.4699 3.25 11.8799 3.25C12.2899 3.25 12.6299 3.59 12.6299 4V14.17C12.6299 14.58 12.2899 14.92 11.8799 14.92Z"
        fill="#1D1D1D"
      />
      <path
        d="M12 20.93C6.85 20.93 3.25 17.33 3.25 12.18C3.25 11.77 3.59 11.43 4 11.43C4.41 11.43 4.75 11.77 4.75 12.18C4.75 16.45 7.73 19.43 12 19.43C16.27 19.43 19.25 16.45 19.25 12.18C19.25 11.77 19.59 11.43 20 11.43C20.41 11.43 20.75 11.77 20.75 12.18C20.75 17.33 17.15 20.93 12 20.93Z"
        fill="#1D1D1D"
      />
    </svg>
  )
}
